export const openMailBox = (email = "support@mindright.io", subject = "Customer Query from Member Portal") => {
   // const subject = "Customer Query from Member Portal";
    const body = ``;
    // Try mailto first
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    // Open mailto link
    try {
        window.location.href = mailtoLink;
    } catch (error) {
        // Gmail compose URL format
        const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(email)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

        // Open in new tab
        window.open(gmailUrl, "_blank");
    }
  

    // Fallback after delay: Open Gmail in browser if mail client is not installed
   
};